import React from 'react';
import { Icon } from '@chakra-ui/react';

export const LinkIcon = () => {
	return (
		<Icon
			width="14px"
			height="14px"
			viewBox="0 0 9 9"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M4.02148 4.39252C4.1799 4.6043 4.38201 4.77954 4.6141 4.90635C4.8462 5.03315 5.10285 5.10856 5.36665 5.12745C5.63045 5.14634 5.89523 5.10828 6.14303 5.01584C6.39082 4.92341 6.61584 4.77876 6.80282 4.59171L7.90946 3.48508C8.24543 3.13723 8.43133 2.67133 8.42713 2.18774C8.42292 1.70414 8.22895 1.24155 7.88699 0.899584C7.54502 0.557619 7.08243 0.363647 6.59883 0.359445C6.11524 0.355242 5.64935 0.541146 5.30149 0.877117L4.66702 1.5079"
				stroke="white"
				stroke-width="0.656815"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M5.49751 3.65468C5.33909 3.4429 5.13698 3.26766 4.90489 3.14085C4.67279 3.01405 4.41614 2.93864 4.15234 2.91975C3.88854 2.90086 3.62376 2.93892 3.37597 3.03136C3.12817 3.12379 2.90315 3.26844 2.71617 3.45548L1.60954 4.56212C1.27357 4.90997 1.08766 5.37587 1.09187 5.85946C1.09607 6.34306 1.29004 6.80565 1.63201 7.14762C1.97397 7.48958 2.43657 7.68355 2.92016 7.68775C3.40375 7.69196 3.86965 7.50605 4.2175 7.17008L4.84828 6.5393"
				stroke="white"
				stroke-width="0.656815"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</Icon>
	);
};

export default LinkIcon;
